
import { PropTypes } from 'prop-types';
import CreatableSelect from 'react-select/creatable';
import Select from 'react-select';
const SelectField = ({ required = true, name, label, options, updateValue, css, isEditable=false }) => {
    const handleChange = (newValue) => {
        updateValue(name, newValue?.value)
    };

    return (
        <div className={`flex flex-col gap-3  ${css}`}>
            <span className='font-bold flex items-center gap-1'>{label}{
                required && <span className='text-red-500'>{`*`}</span>
                }</span>
            {
                isEditable ?

                    <CreatableSelect options={options}
                        name={name}
                        isClearable
                        onChange={handleChange}
                        defaultActiveFirstOption
                        defaultValue={options[0]}
                        styles={{
                            control: (provided) => ({
                                ...provided,
                                
                                border: "1px solid #c7c6c6",
                                outline: "none",

                            }),

                        }}
                        className={` outline-none focus:outline-none py-1 font-normal`} required={required} />
                    :
                    <Select options={options}
                        name={name}
                        onChange={handleChange}
                        defaultActiveFirstOption
                        defaultValue={options[0]}
                        styles={{
                            control: (provided) => ({
                                ...provided,
                                outline: "none",
                                border: "1px solid #c7c6c6",
                                boxShadow: "none",

                            }),

                        }}
                        className={`outline-none focus:outline-none py-1 font-normal`} required={required} />
            }
        </div>
    )
}
SelectField.propTypes = {
    required: PropTypes.bool,
    label: PropTypes.string,
    value: PropTypes.string,
    options: PropTypes.array,
    name: PropTypes.string,
    updateValue: PropTypes.func,
    css: PropTypes.string,
    isEditable: PropTypes.bool
}
export default SelectField